import * as React from 'react'
import { Col, Row, Container, Card } from 'react-bootstrap'
import version from '../../version.json'
import { configuration } from '../../rest-api/Configuration'
import { FaInfo, FaEnvelope, FaCog, FaBook } from 'react-icons/fa'
import Table from 'react-bootstrap/Table'
import Market from '../../model/Market';


interface IHelpComponentProps {
  markets: Market[]
}

export class HelpComponent extends React.Component<IHelpComponentProps, {}> {

  renderDowntimeApiLinks = (): JSX.Element[] => {
    return this.props.markets.map(market => {
      const formattedUrl = configuration.DowntimeAPI(market.key).replace("/api/v1/", "/");
      return (
        <tr>
          <td>{market.name.toUpperCase()} DOWNTIME API</td>
          <td>
            <a href={formattedUrl} target="_blank" rel="noopener noreferrer">{formattedUrl}</a>
          </td>
        </tr>
      )}
    );
  }

  render() {
    let buildStartTime = new Date(version.buildStartTimeInMillis)
    return (
      <Container style={{marginTop: '20px'}}>
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header>
                <FaEnvelope/> Email
              </Card.Header>
              <Card.Body>
                <span>You can send an email to </span>
                <a href="mailto:smartsupport@res-group.com">smartsupport@res-group.com</a>.
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header>
                <FaBook/> Documentation
              </Card.Header>
              <Table striped bordered hover>
                <tbody>
                <tr>
                  <td>SMART Alarm editing user guide</td>
                  <td>
                    <a
                      href="https://reshive.sharepoint.com/:w:/s/Mind_Services48/EYNKT3VjKytEmRToDzKjCu4BvOg_HsvPnZo1rmjgJ4qjXw?e=cu4hYy"
                      target="_blank" rel="noopener noreferrer">
                      https://reshive.sharepoint.com/:w:/s/Mind_Services48/EYNKT3VjKytEmRToDzKjCu4BvOg_HsvPnZo1rmjgJ4qjXw?e=cu4hYy
                    </a>
                  </td>
                </tr>
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header>
                <FaInfo/> Build information
              </Card.Header>
              <Table striped bordered hover>
                <tbody>
                <tr>
                  <td>GIT repository url</td>
                  <td>
                    <a href={version.gitUrl} target="_blank" rel="noopener noreferrer">
                      {version.gitUrl}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Branch name</td>
                  <td>
                    <a
                      href={`${version.gitUrl}/tree/${version.branchName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {version.branchName}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>GIT commit</td>
                  <td>
                    <a
                      href={`${version.gitUrl}/commit/${version.gitCommit}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {version.gitCommit}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Build url</td>
                  <td>
                    <a href={version.buildUrl} target="_blank" rel="noopener noreferrer">
                      {version.buildUrl}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>Build start time</td>
                  <td>{buildStartTime.toUTCString()}</td>
                </tr>
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header>
                <FaCog/> Configuration
              </Card.Header>

              <Table striped bordered hover>
                <tbody>
                <tr>
                  <td>Name</td>
                  <td>{configuration.Name}</td>
                </tr>
                <tr>
                  <td>SMART API</td>
                  <td>
                    <a href={configuration.SmartAPI} target="_blank" rel="noopener noreferrer">
                      {configuration.SmartAPI}
                    </a>
                  </td>
                </tr>
                {this.renderDowntimeApiLinks()}
                <tr>
                  <td>SOLAR GIS PV SPOT API</td>
                  <td>
                    <a
                      href={configuration.SolarGisPvSpotAPI}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {configuration.SolarGisPvSpotAPI}
                    </a>
                  </td>
                </tr>
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    )
  }
}
